import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold rounded-full transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed press-scale';
  const variants = {
    primary: 'bg-coral text-white hover:bg-coral-dark focus:ring-coral shadow-lg shadow-coral/20',
    secondary: 'bg-teal text-white hover:bg-teal-dark focus:ring-teal shadow-lg shadow-teal/20',
    outline: 'border-2 border-coral text-coral hover:bg-coral/10 focus:ring-coral',
    ghost: 'text-charcoal hover:bg-gray-100 focus:ring-gray-400'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${disabled || isLoading ? '!transform-none' : ''} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-182" data-mp="tnopeae4l4uk">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-183" data-mp="12lschb4re9oh" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-184" data-mp="xnqteq7c2ad0">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-185" data-mp="1cc3f8ucpicts">{rightIcon}</span>}
    </button>;
}